/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import Footer from '../components/Footer';
import IntroduceTopMenu from '../components/IntroduceTopMenu';
import * as moment from 'moment';

class Introduce04 extends Component {
  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont" >
              <div id="contents">
                <div className="app-header">
                  <p className="app-logo" onClick={() => {window.location.href = '/'}}><span className="blind">TOZ StudyCenter</span></p>
                  <a href="/introduce" className="app-close"><span className="blind">닫기</span></a>
                </div>

                <div className="info-cont">

                  <IntroduceTopMenu link={this.props.location.pathname} />

                  <div className="info-customer">
                    <div className="channel-cont">
                      <p className="tit"><strong>고객과 소통</strong>하는 다양한 채널</p>
                      <ul className="icons">
                        <li className="naver"><a href="https://blog.naver.com/tozsc_c" target="_blank" rel="noopener noreferrer">공식블로그</a></li>
                        <li className="insta"><a href="https://www.instagram.com/toz_sc" target="_blank" rel="noopener noreferrer">인스타그램</a></li>
                      </ul>
                    </div>

                    <div className="center-info">
                      <p className="btxt">토즈 스터디센터 고객지원</p>
                      <p className="desc">'고객의 소리'를 통해서 토즈 스터디센터 이용 문의 및 불편사항을 남기실 수 있습니다.</p>
                      <a className="btn-voc" href="/voc">고객의 소리<span className="arrow"></span></a>
                    </div>

                    <div className="company-info">
                      <p className="btxt">(주)티스터디컴퍼니</p>
                      <ul className="info">
                        <li>서울특별시 서초구 효령로 72길 57 서초트라팰리스 상가동 2F</li>
                        <li><span className="stxt">대표이사</span> 양강민</li>
                        <li><span className="stxt">사업자등록번호</span> 837-87-02508</li>
                        <li className="copy">©{moment().format("YYYY")}. T STUDY COMPANY Co., LTD. ALL RIGHT RESERVED.</li>
                      </ul>
                      <ul className="clause-btn">
                        <li><a href="/rule/policy/tsc" target="_blank" rel="noopener noreferrer">서비스 이용약관</a></li>
                        <li><a href="/rule/privacy" target="_blank" rel="noopener noreferrer">개인정보 처리방침</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Introduce04;